import React from 'react';
import styled from 'styled-components';
import { createBreakpoint } from '../../util/createBreakpoint';

import { TopNavMenuLink } from './TopNavMenuLink';

const WelcomeSpan = styled.span`
   color: ${({ theme }) => theme.brandColors.lightGray};
   display: none;
`;

const UsernameSpan = styled.span`
   display: none;
`;

const IconSpan = styled.span``;

const NavLink = styled(TopNavMenuLink)`
   font-family: SharpSansSemiBold, sans-serif;
   max-width: 300px;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   color: ${({ theme }) => theme.brandColors.white};

   :after {
      content: none;
   }

   ${({ theme, expandUserAt = 'sm' }) =>
      createBreakpoint('above', expandUserAt, theme)} {
      ${WelcomeSpan}, ${UsernameSpan} {
         display: inline;
      }

      ${IconSpan} {
         display: none;
      }
   }

   &:hover,
   &:focus,
   &:active {
      outline: none;
      color: ${({ theme }) => theme.semanticColors.secondary};
      border-bottom-color: ${({ theme }) => theme.semanticColors.secondary};
   }
`;

const TopNavUserLink = ({ username, ...props }) => (
   <NavLink {...props}>
      <IconSpan>
         <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 16 16"
            size="20"
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
         >
            <path
               fillRule="evenodd"
               d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 100-6 3 3 0 000 6z"
               clipRule="evenodd"
            />
         </svg>
      </IconSpan>
      <WelcomeSpan>Welcome</WelcomeSpan> <UsernameSpan>{username}</UsernameSpan>
   </NavLink>
);

export { TopNavUserLink };
